import Vue from 'vue';
import axios from 'axios';
import VueMoment from 'vue-moment';
import 'moment/locale/ru';
import App from './App.vue';
import router from './router';
import store from './store';
import config from './config';
import 'swiper/swiper-bundle.css';
import LazyLoadDirective from './directives/LazyLoadDirective';

const moment = require('moment');

Vue.config.productionTip = false;

Vue.prototype.$axios = axios.create({
  baseURL: `${config.API_URL}/`,
});

Vue.use(VueMoment, { moment });

Vue.directive('lazyload', LazyLoadDirective);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
